module.exports = __webpack_public_path__ + "static/media/video_mockup.70db9d4b.png";